import Swiper from "swiper";
import {
    Autoplay,
    Navigation,
    Pagination,
    Thumbs,
    FreeMode,
    Mousewheel,
} from "swiper/modules";
import "swiper/css";
import "swiper/css/thumbs";
import "swiper/css/navigation";
import "swiper/css/pagination";

window.Swiper = Swiper;

const velocita = 1000;
const ritardo = 2000;

/* Galleria della scheda: si costruisce quando si apre la lightbox, non prima.
 *
 * Vive dentro #gallery-overlay, che nasce in display:none. Costruirla al
 * caricamento significava creare due Swiper su 16 slide ciascuno - con
 * loop:true, che le CLONA - e far girare un autoplay ogni 600 ms su un
 * contenuto che nessuno sta guardando. Su questa scheda Swiper era la voce
 * piu' grossa del main thread: 1.854 ms di bootup.
 *
 * E' il caso buono per il differimento: chi non apre la galleria non paga
 * niente, e nemmeno gli strumenti di misura la aprono. */
let gallery = null;
let galleryThumbnails = null;

function initGalleriaScheda() {
    if (gallery) {
        return gallery;
    }

    galleryThumbnails = new Swiper(".swiper.thumbnails-gallery", {
        modules: [Navigation, Thumbs, FreeMode, Autoplay, Mousewheel],
        mousewheel: true,
        freeMode: true,
        slidesPerView: "auto",
        speed: 500,
        watchSlidesProgress: true,
        touchRatio: 1,
        allowTouchMove: true,
    });
    gallery = new Swiper(".swiper.gallery", {
        modules: [Navigation, Thumbs, Mousewheel],
        loop: true,
        autoplay: {
            delay: 600,
        },
        speed: 500,
        mousewheel: true,
        spaceBetween: 10,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        thumbs: {
            swiper: galleryThumbnails,
        },
    });

    return gallery;
}

window.initGalleriaScheda = initGalleriaScheda;

/* capture: true perche' la galleria deve esistere prima che l'handler di
 * details.blade.php mostri l'overlay. */
const triggerGalleria = document.getElementById("trigger-open-gallery");
if (triggerGalleria) {
    triggerGalleria.addEventListener("click", initGalleriaScheda, {
        capture: true,
        once: true,
    });
}

const swiper_small_cards = document.querySelectorAll(".swiper_small_cards");

swiper_small_cards.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: ritardo,
                  },
              }
            : {}),
        slidesPerView: 1.5,
        spaceBetween: 15,
        grabCursor: true,
        speed: velocita,
        navigation: {
            nextEl: container.querySelector(".swiper-button-next-evidenza"),
            prevEl: container.querySelector(".swiper-button-prev-evidenza"),
        },
        pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
        },
        breakpoints: {
            320: { slidesPerView: 1.25, centeredSlides: false },
            450: { slidesPerView: 1 },
            768: { slidesPerView: 3 },
            996: { slidesPerView: 3 },
            1200: { slidesPerView: 4 },
            1600: { slidesPerView: 5 },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

/* Hero della home (hero-promozioni.blade.php): una slide per la jumbo e per
 * ogni promozione. Con una slide sola niente autoplay e niente trascinamento.
 * rewind e non loop: con due o tre slide il loop di Swiper non ha abbastanza
 * slide da spostare. Il testo va letto, quindi 6 secondi e non `ritardo`. */
const hero_promozioni = document.querySelectorAll(".swiper-hero-promozioni");

hero_promozioni.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let piuSlide = slides.length > 1;
    new Swiper(container, {
        modules: [Autoplay, Pagination],
        rewind: piuSlide,
        allowTouchMove: piuSlide,
        ...(import.meta.env.PROD && piuSlide
            ? {
                  autoplay: {
                      delay: 6000,
                      pauseOnMouseEnter: true,
                  },
              }
            : {}),
        speed: velocita,
        pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
        },
    });
});

/* "Veicoli in evidenza" della home (auto-in-evidenza.blade.php): la card
 * della lista, con l'ultima tagliata sul bordo come nel Figma (1,2 card su
 * mobile, 4,2 a 1440 e 1920). I pallini si vedono solo su mobile.
 * Stesso carosello per "Per te" (sezione-user-logged.blade.php): lo swiper
 * della scheda nascosta lo aggiorna il Blade quando la scheda si apre. */
const in_evidenza = document.querySelectorAll(
    ".swiper-in-evidenza, .swiper-visualizzate-suggerite",
);

in_evidenza.forEach((container) => {
    new Swiper(container, {
        modules: [Pagination],
        slidesPerView: 1.2,
        spaceBetween: 12,
        grabCursor: true,
        pagination: {
            el: container.querySelector(".swiper-pagination"),
            clickable: true,
        },
        breakpoints: {
            768: { slidesPerView: 2.2, spaceBetween: 20 },
            992: { slidesPerView: 3.2, spaceBetween: 20 },
            1400: { slidesPerView: 4.2, spaceBetween: 20 },
        },
    });
});

// const promozioni_homepage = document.querySelectorAll(
//     ".swiper_promozioni_homepage",
// );

// promozioni_homepage.forEach((container) => {
//     let slides = container.querySelectorAll(".swiper-slide");
//     let enableLoop = slides.length > 3;
//     new Swiper(container, {
//         modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
//         loop: enableLoop,
//         ...(import.meta.env.PROD
//             ? {
//                   autoplay: {
//                       delay: ritardo,
//                   },
//               }
//             : {}),
//         slidesPerView: 1.5,
//         spaceBetween: 15,
//         grabCursor: true,
//         speed: velocita,
//         touchRatio: 1,
//         allowTouchMove: true,
//         navigation: {
//             nextEl: ".swiper-button-next-promozioni",
//             prevEl: ".swiper-button-prev-promozioni",
//         },
//         pagination: {
//             el: ".swiper-pagination",
//             clickable: true,
//         },
//         breakpoints: {
//             320: { slidesPerView: 1.5, centeredSlides: true },
//             450: { slidesPerView: 1 },
//             768: { slidesPerView: 3 },
//             996: { slidesPerView: 3 },
//             1200: { slidesPerView: 3 },
//             1600: { slidesPerView: 3 },
//         },
//     });
//     setTimeout(() => {
//         container.classList.add("visible");
//     }, 250);
// });

const single_container = document.querySelectorAll(
    ".swiper-promo-homepage, .swiper-promo-service",
);

single_container.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length >= 2;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        slidesPerView: 1,
        spaceBetween: 10,
        grabCursor: true,
        speed: 1500,
        touchRatio: 1,
        allowTouchMove: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const blocchi_garanzie_lista = document.querySelectorAll(
    ".swiper-blocchi-garanzie-lista",
);

/* Blocchi garanzie lista */
blocchi_garanzie_lista.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let conteggio_desktop = 4;
    if (slides.lehgth > 4) {
        conteggio_desktop = 5;
    }
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 2000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 2,
        spaceBetween: 0,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            370: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: conteggio_desktop,
            },
            1600: {
                slidesPerView: conteggio_desktop,
            },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const altre_offerte_lista = document.querySelectorAll(
    ".swiper-altre-offerte-lista",
);
/* Altre offerte nella lista */
altre_offerte_lista.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 1,
        spaceBetween: 0,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            996: {
                slidesPerView: 2,
            },
            1200: {
                slidesPerView: 3,
            },
            1600: {
                slidesPerView: 4,
            },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const altre_offerte_lista_preferiti = document.querySelectorAll(
    ".swiper-altre-offerte-lista-preferiti",
);

/* Altre offerte nella lista */
altre_offerte_lista_preferiti.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 6;
    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 4000,
                  },
              }
            : {}),
        grabCursor: true,
        speed: 1500,
        slidesPerView: 2,
        spaceBetween: 10,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            450: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            996: {
                slidesPerView: 3,
            },
            1200: {
                slidesPerView: 5,
            },
            1600: {
                slidesPerView: 5,
            },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const swiper_warranties_search_engine = document.querySelectorAll(
    ".swiper_warranties_search_engine",
);

/* Bottoni Garanzie su motore di ricerca */
swiper_warranties_search_engine.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 3;

    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1500,
                  },
              }
            : {}),
        // slidesPerView: 3,
        slidesPerView: 2,
        grabCursor: true,
        // spaceBetween: 10,
        spaceBetween: 12,
        disableOnInteraction: true,
        speed: 1800,
        touchRatio: 1,
        allowTouchMove: true,
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

const swiper_newsflash = document.querySelectorAll(".swiper_newsflash");

// /* NewsFlash */
swiper_newsflash.forEach((container) => {
    let slides = container.querySelectorAll(".swiper-slide");
    let enableLoop = slides.length > 1;

    new Swiper(container, {
        modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
        loop: enableLoop,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1500,
                  },
              }
            : {}),
        slidesPerView: 1,
        grabCursor: true,
        disableOnInteraction: true,
        speed: 900,
        touchRatio: 1,
        allowTouchMove: true,
        on: {
            init: function () {
                var prevButton = this.navigation.$prevEl;
                var nextButton = this.navigation.$nextEl;

                $(prevButton).addClass("swiper-button-prev_white");
                $(nextButton).addClass("swiper-button-next_white");
            },
        },
    });
});

const altre_offerte = new Swiper(".swiper-altre-offerte", {
    modules: [Autoplay, Navigation, Pagination, Thumbs, FreeMode],
    loop: true,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 4000,
              },
          }
        : {}),
    grabCursor: true,
    speed: 1500,
    slidesPerView: 1,
    spaceBetween: 5,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        450: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 3,
        },
        996: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
        1600: {
            slidesPerView: 4,
        },
    },
});

// /* Stock nelle landing */
const stock_landing = document.querySelectorAll(".swiper-stock-landing");

stock_landing.forEach((container) => {
    // /* Stock nelle landing */
    new Swiper(container, {
        modules: [Autoplay, Navigation, Mousewheel],
        slidesPerView: 3,
        spaceBetween: 20,
        ...(import.meta.env.PROD
            ? {
                  autoplay: {
                      delay: 1800,
                  },
              }
            : {}),
        speed: 500,
        loop: true,
        // mousewheel: true,
        grabCursor: true,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        breakpoints: {
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 2 },
            1440: { slidesPerView: 3 },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});

// /* Slider Immagini Landing page */
const swiper_slider_landing = new Swiper(".swiper-slider-landing", {
    modules: [Autoplay, Navigation, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 20,
    ...(import.meta.env.PROD
        ? {
              autoplay: {
                  delay: 2500,
              },
          }
        : {}),
    speed: 2000,
    loop: true,
    // mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 40 },
        768: { slidesPerView: 1, spaceBetween: 40 },
        1024: { slidesPerView: 2, spaceBetween: 40 },
        1440: { slidesPerView: 2, spaceBetween: 50 },
    },
});

// /* Slider Video Youtube e Vimeo */
const video_landing = new Swiper(".swiper-video-landing", {
    modules: [Navigation, Pagination, Mousewheel],
    slidesPerView: 1,
    spaceBetween: 40,
    autoplay: false,
    speed: 850,
    loop: true,
    // mousewheel: true,
    grabCursor: true,
    touchRatio: 1,
    allowTouchMove: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    breakpoints: {
        0: { slidesPerView: 1, spaceBetween: 40 },
        768: { slidesPerView: 1, spaceBetween: 40 },
        1024: { slidesPerView: 2, spaceBetween: 40 },
        1440: { slidesPerView: 2, spaceBetween: 50 },
    },
});

const stock_landing_brand_models = document.querySelectorAll(
    ".swiper-landing-models, .swiper-landing-brands",
);

stock_landing_brand_models.forEach((container) => {
    new Swiper(container, {
        modules: [Navigation, Pagination, Mousewheel],
        slidesPerView: 2,
        spaceBetween: 10,
        autoplay: {
            delay: 10000,
        },
        speed: 850,
        loop: true,
        // mousewheel: true,
        grabCursor: true,
        touchRatio: 1,
        allowTouchMove: true,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            0: { slidesPerView: 1.5, spaceBetween: 10, centeredSlides: true },
            768: { slidesPerView: 2, spaceBetween: 20 },
            1024: { slidesPerView: 2, spaceBetween: 40 },
            1440: { slidesPerView: 3, spaceBetween: 10 },
        },
    });
    setTimeout(() => {
        container.classList.add("visible");
    }, 250);
});
